var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled from 'styled-components';
import { GRID_UNIT } from '../../../utilities/grid';
import { media } from '../../../utilities/media';
const StyledContainer = styled.section `
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background: ${({ background, backgroundHeight, theme }) => {
    switch (background) {
        case 'top':
            return `linear-gradient(180deg, ${theme.tokens.space.primary.regular} 0px, 
        ${theme.tokens.space.secondary.regular} ${backgroundHeight}px,
         ${theme.tokens.interface.neutral.light} ${backgroundHeight + 1}px, 
         transparent ${backgroundHeight + 2}px)`;
        case 'opaque':
            return theme.tokens.space.secondary.regular;
        default:
            return 'transparent';
    }
}};

  ${media.tablet `
    padding: 0 ${GRID_UNIT * 2}px;
  `};

  &:first-child {
    min-height: 600px;
  }
`;
export class Container extends React.PureComponent {
    render() {
        const _a = this.props, { children } = _a, rest = __rest(_a, ["children"]);
        return React.createElement(StyledContainer, Object.assign({}, rest), children);
    }
}
Container.defaultProps = {
    background: 'transparent',
    backgroundHeight: 100,
};
//# sourceMappingURL=index.js.map